module.exports = __webpack_public_path__ + "files/f805ae8fbde6ce2dea8ca78859d4accf.png";


//////////////////
// WEBPACK FOOTER
// ./images/icons/image.png
// module id = 573
// module chunks = 60